import { Card } from 'ui/components/primitives';
import { styled, utils, theme } from 'ui/theme';

export const Payment = {
  Card: styled(Card)`
    margin-top: ${theme.space[3]};

    ${utils.media.min('l')`
      margin-top: ${theme.space[3]};
      padding: ${theme.space[2]};
    `}

    ${utils.media.max('s')`
      margin-bottom: 60px;
    `}

    > div {
      &[data-spacing='medium'] {
        padding: ${theme.space[4]} ${theme.space[4]} 0 ${theme.space[4]};
      }
    }
  `,
};
